import * as motion from 'motion/react-client';

export function MenuUnderlay({ onClick }: { onClick: () => void }) {
  return (
    <motion.div
      onClick={onClick}
      layoutId='menu-underlay'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { delay: 0.2 } }}
      className='bg-base-black/10 headerLg:block hover-hover:hover:bg-base-black/20 absolute inset-0 top-full z-0 hidden size-full h-[calc(100vh-72px)] cursor-pointer filter backdrop-blur-sm duration-300 ease-out'
    />
  );
}
